module.exports = __webpack_public_path__ + "img/icon_truck.15ee2d04.svg";